import { Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { IItem } from 'src/types/OrderHistory';

export function LineItems({ items }: { items: IItem[] }): JSX.Element {
  return (
    <>
      {items.map((item, index) => (
        // Can not guarantee uniqueness of an item, disabled the rule for this line because data volume is low
        // and there are no re-renders, low risk for performance issues.
        // eslint-disable-next-line react/no-array-index-key
        <LineItem key={item.name + index} item={item} />
      ))}
    </>
  );
}

function LineItem({ item }: { item: IItem }): JSX.Element {
  return (
    <Stack key={item.name} y="sm">
      <Flex justifyContent="space-between">
        <Flex>
          <Stack as="span" x="xx-lg" width="16px">
            <Copy variant="body" color="primaryText">
              {item.quantity}
            </Copy>
          </Stack>
          <Stack as="span" x="xx-lg">
            <Copy variant="body" color="primaryText">
              {item.name}
            </Copy>
          </Stack>
        </Flex>
        <Flex justifyContent="flex-end">
          <Copy variant="body" color="primaryText">
            {item.price}
          </Copy>
        </Flex>
      </Flex>
    </Stack>
  );
}
